"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContainsFocus = void 0;

var _react = require("react");

var useContainsFocus = function useContainsFocus(_ref) {
  var onChange = _ref.onChange;
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handleFocus = debounce(function () {
      if (!ref.current) return;
      onChange(ref.current === document.activeElement || ref.current.contains(document.activeElement));
    });
    document.addEventListener("focus", handleFocus, true);
    document.addEventListener("blur", handleFocus, true);
    return function () {
      document.removeEventListener("focus", handleFocus, true);
      document.removeEventListener("blur", handleFocus, true);
    };
  }, [onChange]);
  return {
    ref: ref
  };
};
/**
 * A simplified debounce that just executes the last function if multiple
 * functions are called within the same tick. Since frequently a blur and a focus
 * will happen concurrently: the last function (the focus) will be executed.
 * If travelling from two elements within the same focus group, `focused` will remain `true`.
 */


exports.useContainsFocus = useContainsFocus;

var debounce = function debounce(callback) {
  var timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback();
    }, 0);
  };
};